export default __webpack_public_path__ + "assets/f9cf07811979f9fc6e3f5da85fbc7ce3.png";